import React from "react"
import ReactDOM from 'react-dom';
import ModalComponent from 'react-modal';
const Modal = ({ children, visible, onClose = () => {} }) => {
    return (
        <ModalComponent
            contentLabel="Example Modal"
            className="relative rounded-lg max-w-[90%]  mx-auto bottom-0 top-0 left-0 right-0 "
            overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
            isOpen={visible}
            onRequestClose={onClose}
            style={{ zIndex: 2000 }}
        >
            {children} 
        </ModalComponent>
    );
};

export default Modal
